<template>

  <div class="calendrier">
    <div v-for="item in list" :key="item.id">
      <router-link v-bind:to="item">
        <img :src="item"/>
      </router-link>
    </div>
  </div>

</template>

<script>

export default {
  name: 'Calendrier',
  components: {
  },
  data() {
    return {
      list: []
    }
  }
  , created() {
    this.fetch()
  }
  , methods: {
    fetch() {
      const url = "https://www.asspm.fr/lab/sdk/api/dir?value=/lab/data/apps/asspm/photos/Calendrier"
      return this.axios.get(url)
          .then(resp => this.list = resp.data)
    }
  }
}

</script>

<style scoped lang="stylus">
  .calendrier
    img
      width 100%
      height auto
</style>